import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Button, Col, Container, Row } from "react-bootstrap";
import { AddSystemAccess } from "../../../../store/actions";
const SubAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    lastName: "",
    email: "",
    phoneNo: "",
    password: "",
    confirmPassword: "",
    role: "accountinguser",
    permissions: {
      dashboard: { view: false, edit: false, delete: false, write: false },
      transaction: { view: false, edit: false, delete: false, write: false },
      user: { view: false, edit: false, delete: false, write: false },
      character: { view: false, edit: false, delete: false, write: false },
      faq: { view: false, edit: false, delete: false, write: false },
      content_pages: { view: false, edit: false, delete: false, write: false },
      general_setting: {
        view: false,
        edit: false,
        delete: false,
        write: false,
      },
      subscription: { view: false, edit: false, delete: false, write: false },
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleModuleChange = (module) => {
    const isChecked = !formData.permissions[module].view;
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [module]: {
          view: isChecked,
          edit: isChecked,
          delete: isChecked,
          write: isChecked,
        },
      },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitting Data:", formData);
    const callback = (err, res) => {
      if (err) {
        toast.error(err);
      } else {
        toast.success(res.message);
      }
    };
    dispatch(
      AddSystemAccess({
        data: formData,
        callback,
      }),
    );
  };

  return (
    <>
      <section className="addForm position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="topHead pb-2">
                <h5 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
                  Add Accounting User:
                </h5>
              </div>

              <div className="cardCstm p-3 rounded bg-white">
                <form onSubmit={handleSubmit} className="">
                  <div className="container">
                    <div className="row g-4">
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <label>Name</label>
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <label>LastName</label>
                          <input
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <label>Email</label>
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <label>Mobile Number</label>
                          <input
                            type="number"
                            name="phoneNo"
                            value={formData.phoneNo}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <label>Password</label>
                          <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <label>Confirm Password</label>
                          <input
                            type="password"
                            name="confirmPassword"
                            value={formData.password}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="form-group">
                          <label>Role</label>
                          <input
                            type="text"
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                            className="form-control"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <h4 className="mt-2">Module Permissions</h4>
                  <div className="container">
                    <div className="row g-4">
                      {Object.keys(formData.permissions).map((module) => {
                        const allChecked = Object.values(
                          formData.permissions[module],
                        ).every(Boolean);
                        return (
                          <div key={module} className="col-md-4 col-lg-3">
                            <div className="card p-3 shadow-sm d-flex justify-content-between align-content-center ">
                              <div className="d-flex align-items-center justify-content-between">
                                <h6 className="fw-bold text-capitalize">
                                  {module.replace(/_/g, " ")}
                                </h6>
                                <div className="px-4 mb-4">
                                  <input
                                    type="checkbox"
                                    className="form-check-input mt-3"
                                    checked={allChecked}
                                    onChange={() => handleModuleChange(module)}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  {/* <div className="container">
                <div className="row g-4 px-4">
                  {Object.keys(formData.permissions).map((module) => (
                    <div key={module} className="col-md-4 col-lg-3">
                      <div className="card p-3 shadow-sm d-flex justify-content-between align-content-center ">
                        <h6 className="fw-bold text-capitalize">
                          {module.replace(/_/g, " ")}
                        </h6>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={formData.permissions[module].view}
                            onChange={() =>
                              handlePermissionChange(module)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div> */}
                  <div className="py-4">
                    <Button
                      type="submit"
                      className="btn border-danger "
                      style={{ backgroundColor: "#000", color: "#fff" }}
                    >
                      Add Accounting User
                    </Button>
                  </div>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <section className="section">
        <div className="section-header">
          <h6>Add Sub User</h6>
          <div className="section-header-breadcrumb ">
            <div className="breadcrumb-item active d-flex justify-content-end">
              <Link to="/">Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{"add"}</div>
          </div>
        </div>
        <div className="section-body">
          <div className="card p-4 d-flex justify-content-center align-content-center p-4">
         
          </div>
        </div>
      </section> */}
    </>
  );
};

export default SubAdmin;
